import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsCardMainData from "./en-us/card-main-data.json";
import localizationEnUsTabPanel from "./en-us/tab-panel.json";
import localizationEnUsCardDetails from "./en-us/card-details.json";
import localizationEnUsCardActivities from "./en-us/card-activities.json";

export const localizationEnUsCaseView = {
  ...localizationEnUsHeader,
  ...localizationEnUsCardMainData,
  ...localizationEnUsTabPanel,
  ...localizationEnUsCardDetails,
  ...localizationEnUsCardActivities,
};
